'use strict';
/**
 *  Load modules
 */

import slick from '../js/slick.min.js';
import '../scss/app.scss';
window.addEventListener("load", function () {
  fft_preloader();
  fft_fix_submenu_pos();
  fft_menu_equal_width();
  fft_show_and_hide_text();
  fft_slick_slider();
  fft_side_lines_width();
  fft_mobile_menu();
  fft_mobile_menu_trigger();
  fft_change_home_link();
  fft_init_contact_button();
});
$(window).resize(function () {
  fft_slick_slider();
  fft_side_lines_width();
  fft_mobile_menu();
  fft_mobile_menu_trigger();
});
$(window).on('orientationchange', function () {
  fft_fix_submenu_pos();
  fft_slick_slider();
  fft_mobile_menu();
  fft_mobile_menu_trigger();
});
/**
 * Hide preloader after small delay for smooth page loading.
 *
 * @since    1.0.0
 */

function fft_preloader() {
  setTimeout(function () {
    $('.fft-preloader').addClass('hidden');
  }, 400);
}

function fft_init_contact_button() {
  $('.contact-info .toggle-btn').click(function () {
    $(this).parent().find('.overlay').toggleClass('show-item');
  });
}
/**
 * Fix submenu position to exclude overflow issues.
 *
 * @since    1.0.0
 */


function fft_fix_submenu_pos() {
  var windowWidth = $(window).width() - 30;
  $('.sub-menu').each(function (i, el) {
    var menuWidth = $(el).width();
    var menuOffset = $(el).offset().left;

    if (menuWidth + menuOffset > windowWidth) {
      $(el).addClass('left');
    } else {
      $(el).removeClass('left');
    }
  });
}
/**
 * Centering menu in flexible container.
 *
 * @since    1.0.0
 */


function fft_menu_equal_width() {
  var minWidht = 0;
  $('.fft-header__container > *:not(.fft-header__nav)').each(function (i, el) {
    minWidht = $(el).width() > minWidht ? $(el).width() : minWidht;
  });
  $('.fft-header__container > *:not(.fft-header__nav)').css('min-width', minWidht + 'px');
}
/**
 * Show & hide hidden text
 *
 * @since    1.0.0
 */


function fft_show_and_hide_text() {
  $('.fft-button.simple').on('click', function () {
    var this_is = $(this);
    var hiddenText = this_is.prev().find('.hidden-text').html();
    console.log(hiddenText);
    this_is.prev().find('.ellipsis').toggleClass('hidden');
    this_is.toggleClass('active');

    if (this_is.hasClass('active')) {
      this_is.prev().find('.visible-text').append('<span class="added">' + hiddenText + '</span>');
    } else {
      this_is.prev().find('.visible-text .added').remove();
    }
  });
}
/**
 * Initialize slick slider
 *
 * @since    1.0.0
 */


var slider = $('.section-logo_slider__list');
var sliderInit = 0;
slider.on('init', function () {
  sliderInit = 1;
});

function fft_slick_slider() {
  if ($('.fft-header__slides').hasClass('slick-initialized')) {
    $('.fft-header__slides').slick('unslick');
  }

  $('.fft-header__slides').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    centerMode: true,
    centerPadding: '0px',
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000
  });

  if (sliderInit < 1) {
    var sliderWidth = 0;
    var slide = $('.section-logo_slider__item');
    var containerWidth = $('.fft-container').width();
    $('.section-logo_slider__item').each(function (i, el) {
      sliderWidth += $(el).outerWidth(true);
    });

    if (slider.length > 0 && sliderWidth - 70 > containerWidth) {
      var slidesToShow = slide.length - 2 > 0 ? slide.length - 2 : slide.length;
      slider.slick({
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        centerPadding: '0px',
        arrows: false,
        dots: true,
        responsive: [{
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            centerMode: false,
            variableWidth: false
          }
        }, {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }]
      });
    }
  }
}
/**
 * Set side line width
 *
 * @since    1.0.0
 */


function fft_side_lines_width() {
  var windowWidth = $('body').width();

  if (windowWidth < 1815) {
    var containerWidth = $('.fft-main .fft-container').width();
    $('.fft-lines').css('width', (windowWidth - containerWidth) / 4 + 'px');
  }
}
/**
 * Mobile menu scripts
 *
 * @since    1.0.0
 */


function fft_mobile_menu() {
  if ($(window).width() < 1200) {
    $('.menu-item a').off();
    $('.menu-item a').on('click', function (e) {
      var this_is = $(this);

      if (this_is.parent().hasClass('menu-item-has-children') && !this_is.hasClass('clicked')) {
        e.preventDefault();
        var sub_menu = this_is.next(); // Mobile menu

        if ($(window).width() < 992) {
          sub_menu.show(); // First level

          if (!this_is.parent().parent().hasClass('sub-menu')) {
            $('.sub-menu').not(sub_menu).hide();
          } // Second level
          else {
              this_is.closest('.sub-menu').find('.sub-menu').not(sub_menu).hide();
            }
        } // Desktop menu
        else {
            sub_menu.addClass('active'); // First level

            if (!this_is.parent().parent().hasClass('sub-menu')) {
              $('.sub-menu').not(sub_menu).removeClass('active');
            } // Second level
            else {
                this_is.closest('.sub-menu').find('.sub-menu').not(sub_menu).removeClass('active');
              }
          }

        var higherLinks = this_is.parents('.menu-item').children('a');
        $('.menu-item a').not(higherLinks).removeClass('clicked');
        this_is.addClass('clicked');
      }
    });

    if ($(window).width() > 991) {
      $('body').on('click', function (e) {
        if ($(e.target).closest('.fft-header__menu').length < 1) {
          $('.sub-menu').removeClass('active');
          $('.menu-item a').removeClass('clicked');
        } else {
          return;
        }
      });
    }
  }
}
/**
 * Toggle mobile menu scripts
 *
 * @since    1.0.0
 */


function fft_mobile_menu_trigger() {
  if ($(window).width() < 992) {
    $('.fft-header__mobile-trigger').off();
    $('.fft-header__mobile-trigger').on('click', function () {
      $(this).toggleClass('active');
      $('.fft-header__nav-wrapper').toggle(); // Close all open sub-menus on menu close

      if ($(this).hasClass('active')) {
        $('.sub-menu').hide();
        $('.menu-item a').removeClass('clicked');
      }
    });
  } else {
    $('.fft-header__nav-wrapper').attr('style', '');
  }
}
/**
 * Toggle mobile menu scripts
 *
 * @since    1.0.0
 */


function fft_change_home_link() {
  $('.menu-wrapper > li:first-child > a').html('<svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M31.888 0.56014C31.1133 -0.186716 29.8865 -0.186713 29.1118 0.560146L0.611901 28.0356C0.0984697 28.5306 -0.112542 29.2615 0.058087 29.954C0.228716 30.6464 0.755167 31.1956 1.43979 31.3954L5.47069 32.5716V51V58C5.47069 59.1046 6.36612 60 7.47069 60H24.8933C25.9978 60 26.8933 59.1046 26.8933 58V38H34.8402V58C34.8402 59.1046 35.7356 60 36.8402 60H54C55.1046 60 56 59.1046 56 58V52V32.6686L59.6718 31.3593C60.3238 31.1268 60.8093 30.5736 60.9551 29.8968C61.101 29.2201 60.8865 28.5161 60.3881 28.0356L31.888 0.56014ZM55.1065 28.5L30.4999 4.77805L5.89348 28.5H9.47069V51V56H22.8933V36C22.8933 34.8954 23.7887 34 24.8933 34H36.8402C37.9447 34 38.8402 34.8954 38.8402 36V56H52V52V28.5H55.1065Z" fill="#005A7C"/></svg>');
}